export default "__VITE_ASSET__BzZXnRmm__"